<script setup lang="ts">
import { computed } from 'vue'

import {
  Table,
  TBody,
  TBodyColumn,
  THead,
  THeadColumn,
  TRow,
} from '@collector/shared-ui'
import { CommonResultId, SportResult } from '@collector/sportsapi-client-legacy'
import { useResults } from '@desktop/views/Relation/components/RelationView/Header/RelationButtons/VerifyResult/VerifyResultModal/useResults'
import {
  useEvent,
  useParticipantResultsMaps,
  useSport,
  useSportMaps,
} from '@desktop/views/Relation/composables'

import Result from './Result.vue'

// composables
const { sport } = useSport()
const { event } = useEvent()
const { eventStatusToSportStatusMap } = useSportMaps()
const { homeParticipantResultsMap, awayParticipantResultsMap } =
  useParticipantResultsMaps()
const { hasParticipantsResultId } = useResults()

// computed
const sportResults = computed(() =>
  sport.value.results
    .filter(filterResult)
    .sort(sortResults)
    .map((result) => ({
      id: result.id,
      name: result.name,
    })),
)

// methods
function sortResults(prevResult: SportResult, nextResult: SportResult): number {
  if (prevResult.id === CommonResultId.Penalty) {
    return 1
  }
  if (nextResult.id === CommonResultId.Penalty) {
    return -1
  }
  return prevResult.id - nextResult.id
}

function filterResult(result: SportResult): boolean {
  return (
    ![CommonResultId.Winner, CommonResultId.Progress].includes(
      result.id as CommonResultId,
    ) &&
    hasParticipantsResultId(result.id) &&
    result.type === 'team'
  )
}
</script>

<template>
  <Table class="border-separate border-spacing-y-1">
    <THead class="bg-neutral-light-9! top-[-1rem]!">
      <TRow class="[&>th]:bg-transparent! [&>th:first-child]:text-left">
        <THeadColumn class="text-neutral-dark-8 px-2">
          Result and status
        </THeadColumn>
        <THeadColumn class="px-2 font-bold!">STATSCORE</THeadColumn>
        <THeadColumn class="text-neutral-dark-8 px-2">Source #1</THeadColumn>
        <THeadColumn class="text-neutral-dark-8 px-2">Source #2</THeadColumn>
      </TRow>
    </THead>
    <TBody
      class="[&>tr]:odd:[&>td]:bg-neutral-light-10! [&>tr]:odd:[&>td]:rounded [&>tr]:even:[&>td]:bg-transparent!"
    >
      <TRow class="[&>td:not(:first-child)]:text-center">
        <TBodyColumn>Status</TBodyColumn>
        <TBodyColumn class="font-bold">
          {{ eventStatusToSportStatusMap[event.status_id].name }}
        </TBodyColumn>
        <TBodyColumn>
          <div />
        </TBodyColumn>
        <TBodyColumn>
          <div />
        </TBodyColumn>
      </TRow>
      <TRow
        v-for="result of sportResults"
        :key="`verify-result-${result.id}`"
        class="[&>td:not(:first-child)]:text-center"
      >
        <TBodyColumn>
          {{ result.name }}
        </TBodyColumn>
        <TBodyColumn class="font-bold">
          <Result
            :homeResult="homeParticipantResultsMap[result.id].value"
            :awayResult="awayParticipantResultsMap[result.id].value"
          />
        </TBodyColumn>
        <TBodyColumn class="text-neutral-dark-9/60 font-bold">
          <Result />
        </TBodyColumn>
        <TBodyColumn class="text-neutral-dark-9/60 font-bold">
          <Result />
        </TBodyColumn>
      </TRow>
    </TBody>
  </Table>
</template>
